import { alpha, styled } from '@mui/material';
import { ButtonStyled } from 'v3/shared/components/Button/defaultStyles';
import { TextButtonStyled } from './types';

export const TextButtonStyles = styled(ButtonStyled)<TextButtonStyled>(
  ({ theme, $outline, fullWidth, width, textColor, marginTop }) => ({
    border: $outline ? '1px solid white' : 'unset',
    width: fullWidth ? '100%' : '',
    maxWidth: width ? `${width}rem` : '',
    whiteSpace: 'nowrap',
    marginTop: marginTop ? `${marginTop}rem` : '',
    color: textColor ?? '',
    padding: '0rem 2rem',

    '&:disabled': {
      color: alpha(theme.palette.common.white, 0.6),
    },
  }),
);
